/**
 * Every object a paged JSON API listing returns, as { name, updated, size }.
 * `fetchPage(params)` resolves to a fetch Response for one page.
 * @param {string} prefix
 * @param {(params: URLSearchParams) => Promise<any>} fetchPage
 * @param {string} failure message prefix used when a page fails
 */
export async function listAllObjects(prefix, fetchPage, failure) {
	const items = [];
	let pageToken = "";
	do {
		const params = new URLSearchParams({ prefix, maxResults: "500" });
		if (pageToken) params.set("pageToken", pageToken);
		const res = await fetchPage(params);
		if (!res.ok) throw new Error(`${failure}: ${res.status}`);
		const data = await res.json();
		for (const o of data.items || []) {
			items.push({ name: o.name, updated: o.updated, size: parseInt(o.size, 10) });
		}
		pageToken = data.nextPageToken || "";
	} while (pageToken);
	return items;
}

/** Markdown objects of a listing as [{ slug, updated, size }]. */
export function markdownSlugs(items) {
	return items
		.filter((i) => i.name.endsWith(".md"))
		.map((i) => ({
			slug: i.name.split("/").pop().replace(/\.md$/, ""),
			updated: i.updated,
			size: i.size,
		}));
}
